"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Reveal = /** @class */ (function () {
    function Reveal() {
        this.config = {
            classNames: {
                hide: 'hide'
            },
            selectors: {
                hide: '.hide'
            }
        };
    }
    Reveal.prototype.closestHideClassName = function (htmlElement) {
        var _a;
        (_a = htmlElement.closest(this.config.selectors.hide)) === null || _a === void 0 ? void 0 : _a.classList.remove(this.config.classNames.hide);
    };
    return Reveal;
}());
exports.default = new Reveal();
